import Vue from "vue";
import { getAction } from "@/api/index";
import store from "../store/index";
/**
 * 单点登录
 */
let that = this
const init = (callback) => {
  if (process.env.VUE_APP_SSO == "true") {
    console.log("-------单点登录开始-------");
    let token = localStorage.getItem("token");
    let st = getUrlParam("ticket");
    let sevice = "http://" + window.location.host + "/";
    if (token) {
      loginSuccess(callback);
    } else {
      if (st) {
        validateSt(st, sevice, callback);
      } else {
        let serviceUrl = encodeURIComponent(sevice);
        window.location.href =
          process.env.VUE_APP_CAS_BASE_URL +
          "/authserver/login?service=" +
          serviceUrl;
      }
    }
    console.log("-------单点登录结束-------");
  } else {
    callback && callback();
  }
};
const SSO = {
  init: init,
};

function getUrlParam(paraName) {
  let url = document.location.toString();
  let arrObj = url.split("?");

  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split("&");
    let arr;

    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");

      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
}

function validateSt(ticket, service, callback) {
  let params = {
    ticket: ticket,
    service: service,
  };
  getAction("/sys/cas/client/validateLogin", params).then((res) => {
    console.log(res)
    if (res.data.success) {
      localStorage.setItem("userState", true);
      localStorage.setItem("userAccount ", res.data.result.userInfo.phone);
      localStorage.setItem("token", res.data.result.token);
      localStorage.setItem("userInfo", JSON.stringify(res.data.result.userInfo));
      store.commit("loginType", 2); // 智慧校园跳转是1，正常登录是2
      store.commit("userInfo", res.data.result.userInfo);
      store.commit(
        "schoolPermission",
        res.data.result.userInfo.organSchoolPermission
          ? res.data.result.userInfo.organSchoolPermission
          : []
      );
      loginSuccess(callback);
    } else {
      let sevice = "http://" + window.location.host + "/";
      let serviceUrl = encodeURIComponent(sevice);
      window.location.href =
        process.env.VUE_APP_CAS_BASE_URL +
        "/authserver/login?service=" +
        serviceUrl;
    }
  });
  // store.dispatch('ValidateLogin',params).then(res => {
  //   //that.departConfirm(res)
  //   if(res.success){
  //     loginSuccess(callback);
  //   }else{
  //     let sevice = "http://"+window.location.host+"/";
  //     let serviceUrl = encodeURIComponent(sevice);
  //     window.location.href = window._CONFIG['casPrefixUrl']+"/login?service="+serviceUrl;
  //   }
  // }).catch((err) => {
  //   console.log(err);
  //   //that.requestFailed(err);
  // });
}

function loginSuccess(callback) {
  callback();
}
export default SSO;
